import type { VideoModel } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const useVideoTutorialsQuery = <T = VideoModel[]>(
	options?: UseQueryOptions<VideoModel[], Error, T>
) =>
	useQuery<VideoModel[], Error, T>({
		queryKey: ['video-tutorials'],
		queryFn: () => client.video.videosList(),
		...(options || {}),
	})
